import { Component, Input } from "@angular/core";
import { PropertyInfoComponent } from "../../../../../integrations/urm/views/property-info/property-info.component";

@Component({
  selector: "scheduler-property-tooltip",
  templateUrl: "./property-tooltip.component.html",
  styleUrls: ["./property-tooltip.component.css"],
  imports: [PropertyInfoComponent]
})
export class PropertyTooltipComponent {
  @Input()
  public externalPropertyReference: string = null;
}
